import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from "../../context/TranslationContext";

const ShippingPolicy = () => {
    const { translateSync } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: false, mirror: true });
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Shipping Policy | Colours Boutique Singapore</title>
                <meta name="description" content="Read the Colours Boutique shipping policy for saree delivery timelines, Singapore delivery details, and shipping charges." />
                <link rel="canonical" href="https://coloursboutique.com/shipping-policy" />
            </Helmet>

            <div className="home-saree-container">
                <section className="about-header-section text-center" style={{ paddingTop: "150px", paddingBottom: "20px" }}>
                    <div className="container">
                        <h1 className="fw-bold display-5 font-51" style={{ color: "#3a3530" }}>{translateSync('Shipping Policy')}</h1>
                        <nav aria-label="breadcrumb" className="boutique-breadcrumb-nav center-align">
                            <ol className="boutique-breadcrumb-ol boutique-breadcrumb-center">
                                <li className="breadcrumb-item"><span onClick={() => window.location.href = "/"}>{translateSync('Home')}</span></li>
                                <li className="breadcrumb-item active">{translateSync('Shipping Policy')}</li>
                            </ol>
                        </nav>
                    </div>
                </section>

                <section className="training-transforms-section py-5 ">
                    <div className="container">
                        <div className="row align-items-stretch">
                            <div className="col-md-12 text-left justify-content-between">
                                <div className="aboutpage-content newww" >
                                    <div className="terms-content" style={{ lineHeight: '1.8' }}>
                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="200">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>1. {translateSync('Singapore Shipping')}</h3>
                                            <p className="mb-2">
                                                {translateSync('We offer standard courier delivery across Singapore. Orders are typically dispatched within 24-48 hours and delivered within 2-3 business days.')}
                                            </p>
                                            <p className="mb-0">
                                                {translateSync('Standard local shipping fees apply at checkout. Enjoy free local delivery for orders above $150 SGD.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="300">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>2. {translateSync('International Shipping (including India)')}</h3>
                                            <p className="mb-2">
                                                {translateSync('We ship our heritage handloom sarees internationally, with a strong shipping network to India. International shipping rates are calculated at checkout based on weight and destination.')}
                                            </p>
                                            <p className="mb-0">
                                                {translateSync('International orders typically take 5-10 business days for delivery, depending on customs processing in the destination country.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="400">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>3. {translateSync('Duties and Taxes')}</h3>
                                            <p className="mb-0">
                                                {translateSync('For shipments outside Singapore (e.g., India or other global destinations), customers are responsible for any customs duty, import taxes, or brokerage fees levied by the destination country.')}
                                            </p>
                                        </div>

                                        <div className="mb-5" data-aos="fade-up" data-aos-delay="500">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>4. {translateSync('Order Tracking')}</h3>
                                            <p className="mb-0">
                                                {translateSync('Once your package is shipped, you will receive a tracking link via email to monitor your saree shipment status in real time.')}
                                            </p>
                                        </div>

                                        <div className="contact-info p-4 rounded-3" style={{ backgroundColor: "#f9f9f9" }} data-aos="fade-up" data-aos-delay="600">
                                            <h3 className="mb-3 fw-semibold" style={{ color: '#3a3530' }}>{translateSync('Questions about Shipping?')}</h3>
                                            <ul className="list-unstyled">
                                                <li className="d-flex mb-2">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Email')}: <a href="mailto:coloursboutiqueadmin@gmail.com" className="text-decoration-none" style={{ color: "#3a3530" }}>coloursboutiqueadmin@gmail.com</a></span>
                                                </li>
                                                <li className="d-flex">
                                                    <span className="me-2" style={{ color: '#3a3530' }}>•</span>
                                                    <span>{translateSync('Phone')}: +91 80562 62626</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ShippingPolicy;
